'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _connector = require('./connector');

var _webClientMessage = require('./webClientMessage');

var _webClientMessage2 = _interopRequireDefault(_webClientMessage);

var _topicConverter = require('./utils/topicConverter');

var _topicConverter2 = _interopRequireDefault(_topicConverter);

var _cookie = require('./utils/cookie');

var _cookie2 = _interopRequireDefault(_cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var topicConverter = (0, _topicConverter2.default)();

/**
 * @class DiffusionSession
 */

var DiffusionSession = function () {
    /**
     * Constructor for DiffusionSession
     * @param {Object} customConfig
     * @param {Boolean} [customConfig.debugConnector] Turn on connector trace logging.
     * @param {Function} [customConfig.onCallbackFunction] On connected handler.
     * @param {Function} customConfig.onDataFunction
     * @memberOf DiffusionSession
     */
    function DiffusionSession(customConfig) {
        _classCallCheck(this, DiffusionSession);

        this.subscriptions = {};
        this.onData = function (data, topic) {
            var message = (0, _webClientMessage2.default)(data, topicConverter.from(topic));
            customConfig.onDataFunction(message);
        };
        this.subscribe = this.subscribe.bind(this);
        this.unsubscribe = this.unsubscribe.bind(this);
        this.unsubscribeAll = this.unsubscribeAll.bind(this);
        if (customConfig.onCallbackFunction) {
            var connector = (0, _connector.getConnector)();
            connector.on('connected', function () {
                customConfig.onCallbackFunction(true);
            });
            connector.on('error', function () {
                customConfig.onCallbackFunction(false);
            });
            connector.connect();
        }
        var logLevel = (0, _cookie2.default)('logLevel');
        if (logLevel) {
            (0, _connector.setLogLevel)(logLevel);
        }
        if (customConfig.debugConnector) {
            (0, _connector.setLogLevel)('debug');
        }
    }

    _createClass(DiffusionSession, [{
        key: 'subscribe',
        value: function subscribe(config) {
            var _this = this;

            var subscribeTopics = config.topics || [config.topic];
            subscribeTopics.filter(function (topic) {
                return _this.subscriptions[topic];
            }).forEach(function (topic) {
                _this.subscriptions[topic].fetch();
            });
            var preparedTopics = subscribeTopics.filter(function (topic) {
                return !_this.subscriptions[topic];
            }).map(topicConverter.to);
            if (preparedTopics.length) {
                (0, _connector.getConnector)().subscribe(preparedTopics).forEach(function (subscription, index) {
                    var topic = preparedTopics[index];
                    subscription.on('update', _this.onData);
                    _this.subscriptions[topic] = subscription;
                });
            }
        }
    }, {
        key: 'unsubscribe',
        value: function unsubscribe(config) {
            var _this2 = this;

            var unsubscribeTopics = config.topics || [config.topic];
            unsubscribeTopics.filter(function (topic) {
                return _this2.subscriptions[topic];
            }).forEach(function (topic) {
                var topicSubscription = _this2.subscriptions[topic];
                topicSubscription.close();
                delete _this2.subscriptions[topic];
            });
        }
    }, {
        key: 'unsubscribeAll',
        value: function unsubscribeAll() {
            this.unsubscribe({
                topics: Object.keys(this.subscriptions)
            });
        }
    }]);

    return DiffusionSession;
}();

exports.default = DiffusionSession;


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/DiffusionSession.js
// module id = 2212
// module chunks = 1